import {
  DateInput,
  NewSelectInput,
  NumberInput,
  RadioInput,
  NewNativeSelectInput,
  TextInput,
} from "./Input";
import { MdClose } from "react-icons/md";

/**
 * @component PTSCard
 * @description Modal card for displaying and editing PTS-related article information.
 *
 * @param {Object} props - Props passed to the PTSCard component
 * @param {Function} props.cancel - Callback function to close the modal
 * @param {Object} props.selectedRow - The data for the currently selected row/article
 * @param {Function} props.handleModalChange - Handler for changes in the input fields
 * @param {Function} props.handleSaveChanges - Callback for saving updated changes
 *
 * @returns {JSX.Element} Rendered PTSCard component
 */

const PTSCard = ({
  cancel,
  selectedRow,
  initialSelectedRow,
  handleModalChange,
  handleSaveChanges,
  fieldConfiguration,
  columnName,
  options,
  hasChanged,
  isEditable,
}) => {
  let findColumn = (name) => {
    let field = fieldConfiguration.find((fld) => fld.key === name);

    if (field) {
      let commonProp = {
        label: field.property,
        name: field.key,
        value: selectedRow[name],
        onChange: handleModalChange,
        placeholder: `Select ${field.property}`,
        // maxLength: field.key === "volume" ? 3 : field.key === "issue" ? 3 : undefined,
      };

      switch (field.fieldType) {
        case "number":
          return <NumberInput {...commonProp} />;
        case "date":
          return <DateInput {...commonProp} />;
        case "yes/no":
          return <RadioInput {...commonProp} />;
        case "dropdown":
          if (field.key === "productionWorkflow") {
            return (
              <NewNativeSelectInput
                {...commonProp}
                options={[
                  "IN-HOUSE",
                  "SUPPLIER COPYEDITING",
                  "ISSUE-MANAGED",
                  "SCE-PROOFS",
                ]}
              />
            );
          }
          return <NewSelectInput {...commonProp} options={options} />;

        default:
          return <TextInput {...commonProp} />;
      }
    } else {
      return null;
    }
  };

  let SaveChanges = () => {
    handleSaveChanges(selectedRow);
  };

  const isDisabled = !hasChanged || !isEditable;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white shadow-lg rounded-lg p-6 w-[1080px] h-[515px]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-[#35424D] font-bold text-[22px] h-[24px]">
            PTS ID: {selectedRow?.pts || "N/A"}
          </h2>
          <button onClick={cancel}>
            <MdClose className="w-[16px] h-[16px] text-[#35424D]" />
          </button>
        </div>

        <hr className="mb-4" />

        <div>
          <h3 className="text-[#5D6871]  text-[18px] h-[24px]  font-semibold mb-4">
            General Information
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-4">
            {[
              { label: "Journal", key: "journalName" },
              { label: "PTS", key: "pts" },
              { label: "DocHead", key: "docHead" },
              { label: "Corr. author", key: "correspondingAuthor" },
            ].map((item, index) => (
              <div key={index}>
                <TextInput
                  label={item.label}
                  name={item.key}
                  value={initialSelectedRow?.[item.key]}
                  disabled={true}
                  onChange={handleModalChange}
                />
              </div>
            ))}
          </div>
          {/* Copyediting Section */}
          <h3 className="text-[#5D6871] text-[18px] h-[24px] font-semibold mb-4">
            Article Meta
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            <div>{findColumn(columnName)}</div>
          </div>
        </div>

        <hr className="mb-2" />
        {/* Footer Section */}
        <div className="flex justify-end">
          <button
            className={`px-4 py-2 rounded ${
              !isDisabled
                ? "bg-[#1C40C9] text-white"
                : "bg-gray-300 text-gray-600 cursor-not-allowed"
            }`}
            onClick={SaveChanges}
            disabled={isDisabled}
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default PTSCard;
